import { SyncStatusEnum } from 'src/graphql/schema';

export const syncStatusOptions = [
  {
    label: 'Connected',
    value: SyncStatusEnum.Active,
    syncStatuses: [SyncStatusEnum.Active],
  },
  {
    label: 'Pending',
    value: SyncStatusEnum.Pending,
    syncStatuses: [SyncStatusEnum.AwaitingSync, SyncStatusEnum.Pending],
  },
  {
    label: 'Disconnected',
    value: SyncStatusEnum.Disconnected,
    syncStatuses: [SyncStatusEnum.Disconnected],
  },
];

// Maps a selected sync status option to the `syncStatuses` query variable and back
export const toSyncStatusesFilter = (syncStatus?: SyncStatusEnum) =>
  syncStatusOptions.find(({ value }) => value === syncStatus)?.syncStatuses;

export const fromSyncStatusesFilter = (syncStatuses?: SyncStatusEnum[]) =>
  syncStatusOptions.find(({ value }) => syncStatuses?.includes(value))?.value;

export const syncStatusMap = {
  [SyncStatusEnum.Active]: {
    label: 'Connected',
    textColor: 'text-green-700',
    dotColor: 'bg-green-500',
  },
  [SyncStatusEnum.AwaitingSync]: {
    label: 'Pending',
    textColor: 'text-gray-500',
    dotColor: 'bg-gray-400',
  },
  [SyncStatusEnum.Pending]: {
    label: 'Pending',
    textColor: 'text-gray-500',
    dotColor: 'bg-gray-400',
  },
  [SyncStatusEnum.Disconnected]: {
    label: 'Disconnected',
    textColor: 'text-rose-700',
    dotColor: 'bg-rose-500',
  },
  [SyncStatusEnum.GracePeriod]: null,
  [SyncStatusEnum.Deleted]: null,
} as const;
